export function useGlobalSearch() {
  const getName = (broker) => {
    const { legal_name, name, dba_name } = broker || {};
    return legal_name || name || dba_name || '-';
  };

  const getPhysicalAddress = (address) => {
    const { city, state } = address || {};
    return `${city || '-'}, ${state || '-'}`;
  };

  const getIdentifiersVSplit = (identifiers) => {
    if (!identifiers || identifiers.length === 0) return '-';
    let result = '';
    identifiers.forEach((identifier) => {
      if (identifier.is_type === 'DOT') {
        result += `DOT ${identifier.value}<br/>`;
      } else if (identifier.is_type === 'MC') {
        result += `MC ${identifier.value}<br/>`;
      }
    });
    return result.trim();
  };

  const getIdentifiersHSplit = (identifiers) => {
    if (!identifiers || identifiers.length === 0) return '-';
    let result = '';
    identifiers.forEach((identifier) => {
      if (identifier.is_type === 'DOT') {
        result += `DOT ${identifier.value} `;
      } else if (identifier.is_type === 'MC') {
        result += ` MC ${identifier.value}`;
      }
    });
    return result.trim();
  };

  const getHighwayStatus = (brokerStatus) => {
    return brokerStatus > 0 ? 'Connected' : 'Not Connected';
  };

  const getConnectionStatus = (broker) => {
    const { connection } = broker || {};
    return connection?.status || null;
  };

  return {
    getName,
    getPhysicalAddress,
    getIdentifiersVSplit,
    getIdentifiersHSplit,
    getHighwayStatus,
    getConnectionStatus,
  };
}
